<template>
    <Bar :data="preparedData" :options="options" />
</template>
<script>
    // vue-chartjs 3 (Vue 2) used a mixin-style API: `extends: Bar` plus an
    // imperative this.renderChart(data, options) call. vue-chartjs 5 (Vue 3)
    // replaced that with a real <Bar> component driven by :data/:options
    // props, registered against chart.js 4's tree-shakeable Chart.register()
    // API. This wrapper keeps the same public props (chartdata/options) so
    // Statistics.vue didn't need to change.
    import { Bar } from 'vue-chartjs'
    import {
        Chart as ChartJS,
        Title,
        Tooltip,
        Legend,
        BarElement,
        CategoryScale,
        LinearScale
    } from 'chart.js'

    ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

    export default {
        name: 'YearsChart',
        components: { Bar },
        props: {
            chartdata: {
                type: Array,
                default: () => []
            },
            options: {
                type: Object,
                default: null
            }
        },
        computed: {
            preparedData() {
                let labels = []
                let counts = []

                for (let item of this.chartdata) {
                    labels.push(item.year)
                    counts.push(item.count)
                }

                return {
                    labels: labels,
                    datasets: [
                        {
                            label: 'Популярность песен этого года',
                            backgroundColor: '#5c6bc0',
                            data: counts
                        }
                    ]
                }
            }
        }
    }
</script>
